module.exports = __webpack_public_path__ + "img/ft_grass.63313389.jpg";